import React, { useContext, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router';

import { Trash2 } from 'lucide-react';
import ImageUploader from '../../../components/ImageUploader';
import ConfirmationModal from '../../../components/ConfirmationModal';
import GlobalContext from '../../../utils/GlobalContext';

export default function ({ documentType, uploading }) {
  const { locales } = useContext(GlobalContext);
  const { bmcId, id: testId } = useParams();
  const {
    testDocument: { collection },
  } = useSelector((state) => state);

  const {
    testDocument: { fetchTestDocuments, addTestDocument, removeTestDocument },
  } = useDispatch();

  useEffect(() => {
    fetchTestDocuments({ bmcId, testId, documentType });
  }, []);

  return (
    <div className="resource-uploader flex gap-4 flex-col">
      {collection.map((document) => (
        <div className="flex flex-row items-center w-full gap-3 justify-center align-center">
          <div
            className="resource-uploader__item w-full"
            key={document.id}
            onClick={() => window.open(document.file, '_black')}
          >
            <i className="icon-Link" />

            <div className="resource-uploader__item-text break-all">
              {document.name}
            </div>
          </div>

          <ConfirmationModal
            body={locales.common.areYouSure}
            confirmText="Delete"
            className="hover:bg-muted-lighter/60 text-foreground"
            onConfirm={() => removeTestDocument({ testId, id: document.id })}
          >
            <Trash2 className="w-5 h-auto" />
          </ConfirmationModal>
        </div>
      ))}

      {collection.map((e) => e.documentType === documentType).length < 3 && (
        <ImageUploader
          title={
            uploading ? locales.common.uploading : locales.common.uploadFile
          }
          icon="icon-Add"
          className="resource-uploader__button"
          onChange={([blob]) => {
            addTestDocument({ documentType, blob, testId });
          }}
        />
      )}
    </div>
  );
}
